<template>
  <div class="quick-menu-area" ref="quickMenuRef" :style="quickMenuStyle">
    <!-- 최근 본 상품 swiper -->
    <div class="recent-product" v-if="recentProducts.length > 0">
      <span>최근 본 상품</span>
      <swiper :modules="quickMenuModules" :slides-per-view="1" :space-between="0" :direction="'horizontal'" :loop="true" :autoplay="{delay: 3000, disableOnInteraction: false}" :navigation="{ nextEl: '.quick-next-btn', prevEl: '.quick-prev-btn'}" :pagination="{el: 'swiper-pagination', type: 'fraction'}" class="recent-product-list">
        <swiper-slide v-for="(product, index) in recentProducts" :key="index" class="recent-item">
          <NuxtLink :to="product.link" class="recent-link">
            <img :src="cu.getFileFullUrl(product.image)" :alt="product.text">
          </NuxtLink>
          <button type="button" class="btn-close" @click="deleteRecentViewProduct(index)" aria-label="최근 본 상품 삭제"></button>
        </swiper-slide>
      </swiper>
      <!-- navigation Buttons -->
      <div class="pagination">
        <button type="button" class="swiper-button-prev quick-prev-btn" aria-label="이전"></button>
        <div class="swiper-pagination"></div>
        <button type="button" class="swiper-button-next quick-next-btn" aria-label="다음"></button>
      </div>
    </div>
    <button
      type="button"
      class="btn-qna"
      aria-label="1:1 문의 바로가기"
      @click="moveInquiryPage"
    ></button>
    <button
      type="button"
      class="btn-top"
      aria-label="상단 바로가기" @click="scrollToTop"
    ></button>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted} from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
// 최근 본 상품 썸네일 임시 이미지
import recentItem1 from '@/assets/images/pc/main-hcon/img-quick-product.png'

// swiper modules
const quickMenuModules = [Navigation, Pagination]
const { refreshRecentProductList, recentProducts } = useHeader()

// refs
const quickMenuRef = ref(null)
const quickMenuStyle = ref({positon: 'fixed', bottom: '145px', top: 'auto'})

const moveInquiryPage = () => {
  navigateTo({path: '/pc/inquiry/list'}, {replace: false});
}

const deleteRecentViewProduct = (key : number) => {
  const recentViewList = sessionStorage.getItem("product.recentViewList")
  const recentViewListBefore : RecentProduct[] = recentViewList ? JSON.parse(recentViewList) : [];
  const recentViewListAfter = recentViewListBefore.filter(item => item.index !== key);
  sessionStorage.setItem("product.recentViewList", JSON.stringify(recentViewListAfter))
  refreshRecentProductList();
}

// top
const scrollToTop = () => {
  const scrollStep = () => {
    if (window.scrollY != 0) {
      setTimeout(function () {
        window.scrollTo(0, window.scrollY - 100);
        scrollStep();
      }, 10);
    }
  }

  scrollStep()
}

// 퀵메뉴 에니메이션
const handleScroll = () => {
  const footer = document.querySelector('footer') || document.querySelector('.footer')
  if (!footer) return

  const footerTop = footer.offsetTop;
  const scrollY = window.scrollY;
  const windowHeight = window.innerHeight;
  const footerHeight = footer.offsetHeight;

  const triggerPoint = footerTop - windowHeight + 71;
  
  if (scrollY >= triggerPoint) {
    quickMenuStyle.value = {
      positon: 'absolute',
      bottom: `${footerHeight + 71}px`,
      top: 'auto'
    }
  } else {
    quickMenuStyle.value = {
      positon: 'fixed',
      bottom: '150px',
      top: 'auto',
    }
  }
}
watch (recentProducts, (newVal, olVal) =>{

})
interface RecentProduct  {
  index: number;
  text: string,
  link: string;
  image: string; 
}
// 라이프사이클
onMounted(() => {
  const sessionlist = sessionStorage.getItem('product.recentViewList');
  const rcntProductList: RecentProduct[] = sessionlist ? JSON.parse(sessionlist) : [];
  recentProducts.value = rcntProductList;
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>
<style lang="scss" scoped>
</style>